import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ListProfessionalsComponent } from './list-professionals/list-professionals.component';
import { CreateProfessionalComponent } from './create-professional/create-professional.component';
import { EditProfessionalComponent } from './edit-professional/edit-professional.component';
import { CalendarScaleProfessionalComponent } from './calendar-scale-professional/calendar-scale-professional.component';
import { ListProfessionalsContractsComponent } from './list-professionals-contracts/list-professionals-contracts.component';
import { ReviewFilesComponent } from './review-files/review-files.component';
import { ListInactiveProfessionalsComponent } from './list-inactive-professionals/list-inactive-professionals.component';

const routes: Routes = [
  { path: '', component: ListProfessionalsComponent },
  { path: 'contracts', component: ListProfessionalsContractsComponent },
  { path: 'register', component: CreateProfessionalComponent },
  { path: 'inactive', component: ListInactiveProfessionalsComponent },
  { path: 'review-files', component: ReviewFilesComponent },
  { path: ':id', component: EditProfessionalComponent },
  { path: 'scale/:id', component: CalendarScaleProfessionalComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  declarations: [],
})
export class ProfessionalsRoutingModule {}
